// extracted by mini-css-extract-plugin
export default {"scrolled":"OptionVariationThumbnail__scrolled___oeN4s","grow":"OptionVariationThumbnail__grow___OSFsH"};